import { html, rune, type Html, View } from 'rune-ts';
import klass from './LinksSection.module.scss';
import { HandmadeLandingMainMessage, HandmadeLogo } from '../../icons';
import { typoPcMo } from '../../../../../shared/typography/typo';
import { LinkCard } from './LinkCard';
import { map, pipe, range, toArray } from '@fxts/core';
import { LinkCreator } from './LinkCreator';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger.js';
import { PauseScrollSmootherEvent, SetScrollIndexEvent } from '../../HandmadeCreatorLandingPage';
import { ONE_SCROLL_INDEX_MAP_MO, ONE_SCROLL_INDEX_MAP_PC } from '../../const';

export class LinksSection extends View {
  linkCreator = new LinkCreator();
  constructor() {
    super({});
  }

  override template(): Html {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    const texts = {
      title: html.preventEscape(ET(`mps2::landing::handmade::links_title`)),
    };
    return html`
      <section class="${klass.links}">
        <div class="${klass.main_video}">
          <video
            preload="none"
            autoplay=""
            loop=""
            muted=""
            playsinline=""
            src="//s3.ap-northeast-2.amazonaws.com/s3.marpple.co/files/u_4648126/2024/10/original/bowl_painting.mp4"
          ></video>
        </div>
        <div class="${klass.links_wrapper}">
          <div class="${klass.slogan_wrapper}">
            <div class="${klass.slogan}">
              <div class="${klass.message}">${HandmadeLandingMainMessage}</div>
              <div class="${klass.logo}">${HandmadeLogo}</div>
            </div>
            <div class="${klass.text} ${typoPcMo({ is_mobile, pc: '28_bold', mo: '20_bold' })}">
              ${texts.title}
            </div>
          </div>
          ${this._renderCardList()} ${this.linkCreator}
        </div>
      </section>
    `;
  }

  private _renderCardList() {
    return pipe(
      range(1, 6),
      map((card_number) => new LinkCard({ card_number })),
      toArray,
    );
  }

  override onRender() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    if (!is_mobile) this.pinVideo();
    this.initLinksSectionScrollTrigger();
  }

  pinVideo() {
    return gsap.to(`.${klass.main_video}`, {
      scrollTrigger: {
        trigger: `.${klass.links}`,
        pin: `.${klass.main_video}`,
        start: 'top top',
        end: 'bottom bottom',
      },
    });
  }

  initLinksSectionScrollTrigger() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    ScrollTrigger.create({
      trigger: `.${klass.links}`,
      start: 'top top',
      end: '+=100px',
      onEnter: () => {
        this.dispatchEvent(SetScrollIndexEvent, {
          bubbles: true,
          detail: {
            current_index: is_mobile
              ? ONE_SCROLL_INDEX_MAP_MO.last_index
              : ONE_SCROLL_INDEX_MAP_PC.last_index,
          },
        });
      },
      onEnterBack: () => {
        this.dispatchEvent(PauseScrollSmootherEvent, {
          bubbles: true,
          detail: { is_paused: true },
        });
      },
    });
  }
}
